namespace RioERP.Reports {
    export class OrderProductReportColumns {
        static columnsKey = 'Reports.OrderProductReport';
    }
}
